import React from "react";
import "./HeroFleet.css";
import hero from "../../assets/heroservice.jpeg";

/**
 * Premium HeroFleet - High End UI Design
 * Maintains left-aligned content with enhanced visuals
 *
 * NOTE: The CTA is an <a href="tel:+12533192612"> link so it opens the dialer.
 */
export default function HeroFleet({
  bgSrc = hero,
  phoneNumber = "253-319-2612", // customize if needed
}) {
  const bgUrl = typeof bgSrc === "string" && bgSrc.length ? bgSrc : hero;

  // Build a safe tel: URL (strip non-digits, add +1 for US)
  const digits = phoneNumber.replace(/\D+/g, "");
  const telHref =
    digits.startsWith("1") && digits.length === 11
      ? `tel:+${digits}`
      : `tel:+1${digits}`;

  return (
    <section className="HeroFleet">
      <div
        className="HeroFleet-hero"
        style={{ "--hf-bg": `url("${bgUrl}")` }}
        aria-label="Keep your fleet on the road"
      >
        {/* Enhanced overlays */}
        <div className="HeroFleet-vignette-overlay" aria-hidden="true" />
        <div className="HeroFleet-animated-glow" aria-hidden="true" />
        <div className="HeroFleet-glass-panel" aria-hidden="true" />
        <div className="HeroFleet-particle-layer" aria-hidden="true" />

        {/* Floating elements for depth */}
        <div className="HeroFleet-floating-orb HeroFleet-orb-1" aria-hidden="true" />
        <div className="HeroFleet-floating-orb HeroFleet-orb-2" aria-hidden="true" />

        {/* Content container */}
        <div className="HeroFleet-inner">
          {/* Premium badge */}
          <div className="HeroFleet-kicker">
            <span className="HeroFleet-kicker-text">STAY IN MOTION</span>
            <div className="HeroFleet-kicker-glow" aria-hidden="true" />
          </div>

          {/* Title */}
          <h1 className="HeroFleet-title">
            <span className="HeroFleet-title-line">KEEP YOUR</span>
            <span className="HeroFleet-title-line">
              FLEET <span className="HeroFleet-title-accent">ON THE</span>
            </span>
            <span className="HeroFleet-title-line">ROAD</span>
          </h1>

          {/* Description */}
          <div className="HeroFleet-content">
            <p className="HeroFleet-lead">
              At Dempsey Mobile Service, we understand the importance of minimizing
              downtime and maximizing efficiency for your fleet. Our comprehensive
              maintenance and rapid-response repair services ensure your vehicles
              stay on the road, running smoothly and reliably.
            </p>
            <div className="HeroFleet-card-glow" aria-hidden="true" />
          </div>

          {/* CTA: tel link (styled like a button via existing styles) */}
          <a className="HeroFleet-cta" href={telHref}>
            <span className="HeroFleet-cta-text">Call Us Now</span>
            <span className="HeroFleet-cta-arrow" aria-hidden="true">▸</span>
          </a>

          {/* Optional: If you prefer keeping a <button>, uncomment below:
              <button className="HeroFleet-cta" onClick={() => (window.location.href = telHref)}>
                <span className="HeroFleet-cta-text">Call Us Now</span>
                <span className="HeroFleet-cta-arrow" aria-hidden="true">▸</span>
              </button>
          */}
        </div>
      </div>
    </section>
  );
}
